import ConferenceTemplate1, {
  type ConferenceTemplate1Props,
} from "../../conference/template-1/ConferenceTemplate1";

export type ChurchTemplate1Props = ConferenceTemplate1Props;

export default function ChurchTemplate1(props: ChurchTemplate1Props) {
  return <ConferenceTemplate1 {...props} />;
}
